var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeavesCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 84,
    viewBox: "0 0 114 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 84,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin Flow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -226,
    y: -154,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 422198"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2892_239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: -34,
    width: 152,
    height: 118,
    rx: 12,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2303",
    opacity: 0.08,
    cx: 73,
    cy: 73,
    r: 73,
    fill: "url(#paint0_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.85 21.2578H82.43C85.11 21.2578 87.28 23.4278 87.28 26.1078V55.1678C87.28 57.8478 85.11 60.0178 82.43 60.0178H80.857C80.1115 60.0178 79.6281 60.8043 79.9648 61.4694L82.6082 66.6917C83.1307 67.7239 81.7751 68.6714 80.9853 67.826L73.9865 60.3351C73.7973 60.1327 73.5328 60.0178 73.2558 60.0178H45.85C43.17 60.0178 41 57.8478 41 55.1678V26.1078C41 23.4278 43.17 21.2578 45.85 21.2578Z",
    fill: "url(#paint1_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.9437 18.6406H48.3438C47.2392 18.6406 46.3438 19.5361 46.3438 20.6406V49.8306C46.3438 52.0398 48.1346 53.8306 50.3438 53.8306H77.9437C80.1529 53.8306 81.9437 52.0398 81.9437 49.8306V20.6406C81.9437 19.5361 81.0483 18.6406 79.9437 18.6406Z",
    fill: "url(#paint2_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.9437 18.6406H48.3438C47.2392 18.6406 46.3438 19.5361 46.3438 20.6406V26.9006H81.9437V20.6406C81.9437 19.5361 81.0483 18.6406 79.9437 18.6406Z",
    fill: "#2C4071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.1031 23.92C51.3331 23.92 50.7031 23.29 50.7031 22.52V17.4C50.7031 16.63 51.3331 16 52.1031 16C52.8731 16 53.5031 16.63 53.5031 17.4V22.52C53.5031 23.29 52.8731 23.92 52.1031 23.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.1187 23.92C57.3487 23.92 56.7188 23.29 56.7188 22.52V17.4C56.7188 16.63 57.3487 16 58.1187 16C58.8887 16 59.5187 16.63 59.5187 17.4V22.52C59.5187 23.29 58.8887 23.92 58.1187 23.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M64.1422 23.92C63.3722 23.92 62.7422 23.29 62.7422 22.52V17.4C62.7422 16.63 63.3722 16 64.1422 16C64.9122 16 65.5422 16.63 65.5422 17.4V22.52C65.5422 23.29 64.9122 23.92 64.1422 23.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M70.1578 23.92C69.3878 23.92 68.7578 23.29 68.7578 22.52V17.4C68.7578 16.63 69.3878 16 70.1578 16C70.9278 16 71.5578 16.63 71.5578 17.4V22.52C71.5578 23.29 70.9278 23.92 70.1578 23.92Z",
    fill: "#4A5D8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.1813 23.92C75.4113 23.92 74.7812 23.29 74.7812 22.52V17.4C74.7812 16.63 75.4113 16 76.1813 16C76.9513 16 77.5812 16.63 77.5812 17.4V22.52C77.5812 23.29 76.9513 23.92 76.1813 23.92Z",
    fill: "#4A5D8B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352865"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2318",
    cx: 89.2578,
    cy: 59,
    r: 18,
    fill: "#1D2B4E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2317",
    cx: 89.2578,
    cy: 59,
    r: 15,
    fill: "url(#paint3_linear_2892_239)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352859"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10868",
    x: 51.2578,
    y: 29,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 294",
    d: "M53.0078 32.0015L53.7206 32.8516L55.5078 31.3516",
    stroke: "#47619E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10869",
    x: 61.2578,
    y: 29,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10871",
    x: 71.2578,
    y: 29,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 293",
    d: "M73.0078 32.0015L73.7206 32.8516L75.5078 31.3516",
    stroke: "#47619E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 292",
    d: "M63.0078 32.0015L63.7206 32.8516L65.5078 31.3516",
    stroke: "#47619E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352860"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10868_2",
    x: 51.2578,
    y: 37,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 294_2",
    d: "M53.0078 40.0015L53.7206 40.8516L55.5078 39.3516",
    stroke: "#47619E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10869_2",
    x: 61.2578,
    y: 37,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10871_2",
    x: 71.2578,
    y: 37,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352861"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10868_3",
    x: 51.2578,
    y: 45,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10869_3",
    x: 61.2578,
    y: 45,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10871_3",
    x: 71.2578,
    y: 45,
    width: 6,
    height: 6,
    rx: 2,
    fill: "#213158",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip1_2892_239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5078 66.0625H86.0078C85.3862 66.0625 84.7901 65.8156 84.3505 65.376C83.911 64.9365 83.6641 64.3404 83.6641 63.7188C83.6636 63.6628 83.6731 63.6073 83.6922 63.5547C84.1427 62.3664 84.943 61.3427 85.9874 60.6187C87.0319 59.8948 88.2714 59.5047 89.5422 59.5H89.9735C91.2443 59.5047 92.4837 59.8948 93.5282 60.6187C94.5727 61.3427 95.373 62.3664 95.8235 63.5547C95.8425 63.6073 95.8521 63.6628 95.8516 63.7188C95.8516 64.3404 95.6046 64.9365 95.1651 65.376C94.7256 65.8156 94.1294 66.0625 93.5078 66.0625ZM84.6016 63.7984C84.622 64.1574 84.7791 64.495 85.0406 64.7417C85.3022 64.9884 85.6483 65.1256 86.0078 65.125H93.5078C93.8674 65.1256 94.2135 64.9884 94.4751 64.7417C94.7366 64.495 94.8937 64.1574 94.9141 63.7984C94.5196 62.8094 93.8384 61.961 92.958 61.3621C92.0776 60.7632 91.0382 60.4412 89.9735 60.4375H89.5422C88.4774 60.4412 87.4381 60.7632 86.5577 61.3621C85.6773 61.961 84.9961 62.8094 84.6016 63.7984Z",
    fill: "#021239",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0266 63.7195C96.0272 63.643 96.0141 63.5669 95.9879 63.495L95.988 63.495L95.9871 63.4927C95.5241 62.2712 94.7015 61.219 93.6279 60.4749C92.5543 59.7308 91.2803 59.3299 89.9741 59.325H89.9735L89.5422 59.325L89.5416 59.325C88.2353 59.3299 86.9613 59.7308 85.8878 60.4749C84.8142 61.219 83.9916 62.2712 83.5286 63.4927L83.5286 63.4926L83.5277 63.495C83.5015 63.5672 83.4884 63.6435 83.4891 63.7203L83.6641 63.7188H83.4891C83.4891 64.3868 83.7544 65.0274 84.2268 65.4998C84.6992 65.9721 85.3398 66.2375 86.0078 66.2375H93.5078C94.1758 66.2375 94.8165 65.9721 95.2889 65.4998C95.761 65.0276 96.0264 64.3873 96.0266 63.7195ZM96.0266 63.7195C96.0266 63.7198 96.0266 63.72 96.0266 63.7203L95.8516 63.7188H96.0266C96.0266 63.719 96.0266 63.7193 96.0266 63.7195ZM86.0078 64.95L86.0075 64.95C85.6927 64.9505 85.3897 64.8304 85.1607 64.6144C84.9409 64.407 84.8053 64.1265 84.779 63.8263C85.1627 62.8856 85.8156 62.0786 86.6561 61.5068C87.5076 60.9275 88.5128 60.6161 89.5425 60.6125H89.9731C91.0029 60.6161 92.0081 60.9275 92.8596 61.5068C93.7001 62.0786 94.3529 62.8856 94.7366 63.8263C94.7103 64.1265 94.5748 64.407 94.355 64.6144C94.126 64.8304 93.8229 64.9505 93.5081 64.95H93.5078H86.0078ZM84.6016 63.7984C84.622 64.1574 84.7791 64.495 85.0406 64.7417C85.3022 64.9884 85.6483 65.1256 86.0078 65.125L84.6016 63.7984Z",
    stroke: "#021239",
    strokeOpacity: 0.7,
    strokeWidth: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7578 58.0313C89.2016 58.0313 88.6578 57.8663 88.1953 57.5573C87.7328 57.2482 87.3723 56.809 87.1594 56.295C86.9465 55.7811 86.8908 55.2156 86.9994 54.6701C87.1079 54.1245 87.3757 53.6233 87.7691 53.23C88.1624 52.8367 88.6636 52.5688 89.2091 52.4603C89.7547 52.3518 90.3202 52.4075 90.8341 52.6203C91.348 52.8332 91.7873 53.1937 92.0963 53.6562C92.4054 54.1187 92.5703 54.6625 92.5703 55.2188C92.5703 55.9647 92.274 56.68 91.7466 57.2075C91.2191 57.7349 90.5037 58.0313 89.7578 58.0313ZM89.7578 53.3438C89.387 53.3438 89.0245 53.4537 88.7161 53.6597C88.4078 53.8658 88.1675 54.1586 88.0255 54.5012C87.8836 54.8438 87.8465 55.2208 87.9188 55.5845C87.9912 55.9483 88.1698 56.2824 88.432 56.5446C88.6942 56.8068 89.0283 56.9854 89.392 57.0577C89.7557 57.1301 90.1327 57.0929 90.4753 56.951C90.818 56.8091 91.1108 56.5688 91.3168 56.2604C91.5228 55.9521 91.6328 55.5896 91.6328 55.2188C91.6328 54.7215 91.4353 54.2446 91.0836 53.8929C90.732 53.5413 90.2551 53.3438 89.7578 53.3438Z",
    fill: "#021239",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.098 57.7028C88.5893 58.031 89.1669 58.2063 89.7578 58.2063C90.5501 58.2063 91.31 57.8915 91.8703 57.3312C92.4306 56.771 92.7453 56.0111 92.7453 55.2188C92.7453 54.6279 92.5701 54.0503 92.2418 53.559C91.9136 53.0677 91.447 52.6848 90.9011 52.4587C90.3552 52.2325 89.7545 52.1734 89.175 52.2887C88.5955 52.4039 88.0631 52.6885 87.6453 53.1063C87.2275 53.5241 86.943 54.0564 86.8277 54.6359C86.7124 55.2154 86.7716 55.8161 86.9977 56.362C87.2238 56.9079 87.6068 57.3745 88.098 57.7028ZM88.8133 53.8053C89.0929 53.6185 89.4216 53.5188 89.7578 53.5188C90.2087 53.5188 90.6411 53.6979 90.9599 54.0167C91.2787 54.3355 91.4578 54.7679 91.4578 55.2188C91.4578 55.555 91.3581 55.8837 91.1713 56.1632C90.9845 56.4428 90.719 56.6607 90.4084 56.7893C90.0977 56.918 89.7559 56.9517 89.4262 56.8861C89.0964 56.8205 88.7935 56.6586 88.5557 56.4208C88.318 56.1831 88.1561 55.8802 88.0905 55.5504C88.0249 55.2206 88.0585 54.8788 88.1872 54.5682C88.3159 54.2576 88.5338 53.9921 88.8133 53.8053Z",
    stroke: "#021239",
    strokeOpacity: 0.7,
    strokeWidth: 0.35
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    y: -33.5,
    width: 151,
    height: 117,
    rx: 11.5,
    stroke: "url(#paint4_linear_2892_239)",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2892_239",
    x1: 73,
    y1: -44,
    x2: 73,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2892_239",
    x1: 64.14,
    y1: 21.2578,
    x2: 64.14,
    y2: 75.3828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4F7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2892_239",
    x1: 64.1438,
    y1: 18.6406,
    x2: 64.1438,
    y2: 58.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5470B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576B9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2892_239",
    x1: 89.2578,
    y1: 44,
    x2: 89.2578,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6377A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#314577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2892_239",
    x1: -38,
    y1: -37,
    x2: 38,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: -34,
    width: 152,
    height: 118,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white",
    transform: "translate(82.2578 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavesCardIcon);
export default __webpack_public_path__ + "static/media/LeavesCardIcon.03618bab705d7069532bebef2a29be1c.svg";
export { ForwardRef as ReactComponent };